<template>
  <div class="fadein">
    <div class=" p_0">
      <ticket-table-component
          :columns="columns"
          :rows="invoices"
          :sortable="sortable"
          :pagination="pagination"
          @sorting="sorting"
          @pageChanged="pageChanged"
      >
        <template v-slot:action="{ row }">
          <a href="javascript:void(0)" class="btn btn_black mb_5" @click="downloadCloudInvoicePDF(row.id)">
            Download
          </a>
          <a href="javascript:void(0)" class="btn btn_info btn-sm" @click="openInvoiceHistoryModal(row.id)">
            Details
          </a>
          <a v-if="row.status === 'failed'" href="javascript:void(0)" class="btn btn_black btn-sm mt_5"
             @click="rePayFailedPayment(row.id)"
          >
            Re-payment
          </a>
        </template>
      </ticket-table-component>
    </div>

    <BaseModal
        v-if="isShowDetailsModal"
        title="Invoice Payment History"
        :closeModal="closeInvoiceHistoryModal"
        size="modal_1060p"
    >
      <InvoicePaymentHistory
          :closeModal="closeInvoiceHistoryModal"
          :invoiceId="selectedInvoiceId"
      />
    </BaseModal>

  </div>
</template>

<script>
import TicketTableComponent from "@/components/shared/TicketTableComponent";
import BaseModal from "@/components/BaseModal.vue";
import InvoicePaymentHistory from "@/views/customers/InvoicePaymentHistory.vue";

export default {
  name: 'CustomerBillInvoiceList',
  components: {InvoicePaymentHistory, BaseModal, TicketTableComponent},
  data() {
    return {
      lyLoading: false,
      activeTab: 'activityList',
      customer_id: this.$route.params.id,
      isShowDetailsModal: false,
      selectedInvoiceId: null,
      billings: [],
      tickets: [],
      invoices: [],
      filter: {
        server_region_id: '',
      },
      queryParams: {
        page: 1,
        search: '',
        search_columns: 'invoice_number,invoice_date,month_of_invoice,total_amount',
        sort: 'created_at',
        sort_order: 'desc',
        per_page: 10
      },
      sortable: {
        order: 'created_at',
        sort: 'desc'
      },
      columns: [
        {
          label: "Invoice ID",
          field: "invoice_number",
        },
        {
          label: "Invoice Date",
          field: "invoice_date",
        },
        {
          label: "Month of Invoice",
          field: "month_of_invoice",
        },
        {
          label: "Total Amount",
          field: "total_amount",
        },
        {
          label: "Payment Method",
          field: "paymentMethod.name",
        },
        {
          label: "Status",
          field: "status",
        },
        {
          label: "Paid At",
          field: "paid_at",
        },
        {
          label: "Action",
          field: "action",
          sortable: false,
          slot: true,
        },
      ],
      pagination: null,
    }
  },
  watch: {
    $route(to, from) {
      if (to.name === from.name && !window._.isEqual(to, from)) {
        this.loadContactData()
      }
    },
  },
  created() {
    if (this.$route.params.id) {
      this.loadContactData()
    }
  },
  mounted() {
    this.ticketScrollbar()
  },
  methods: {
    searchQuery() {
      // A new search/filter changes the result set, so the old page number
      // no longer means anything — start from the first page.
      this.queryParams.page = 1;
      this.changeRoute();
    },
    sorting({column, order}) {
      this.queryParams.sort = column;
      this.queryParams.sort_order = order;
      this.queryParams.page = 1;
      this.changeRoute()
    },
    pageChanged(page) {
      this.queryParams.page = page;
      this.changeRoute()
    },
    changeRoute() {
      this.$router.push({name: this.$route.name, query: {...this.queryParams, ...this.filter}})
    },
    loadContactData() {
      this.lyLoading = true;
      this.axios.get('/customer-billing-invoices/' + this.$route.params.id, {
        params: {...this.queryParams, ...this.filter}
      })
          .then(({data}) => {
            this.invoices = data.data
            this.pagination = data.meta
          })
          .catch(() => {
          })
          .finally(() => {
            this.ticketScrollbar()
            this.lyLoading = false;
          })
    },
    async downloadCloudInvoicePDF(invoiceId) {
      try {
        const response = await this.axios({
          url: `/download-customer-billing-invoices/${this.customer_id}/${invoiceId}`,
          method: 'GET',
          responseType: 'blob',
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `Vlan24 Cloud Invoice- ${new Date().toLocaleDateString()}.pdf`);
        document.body.appendChild(link);
        link.click();

        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
      } catch (error) {
        console.error('There was an error downloading the PDF:', error);
      }
    },
    openInvoiceHistoryModal(invoiceId) {
      this.selectedInvoiceId = invoiceId
      this.isShowDetailsModal = true
    },
    closeInvoiceHistoryModal() {
      this.selectedInvoiceId = null
      this.isShowDetailsModal = false
    },
    rePayFailedPayment(id){
      this.axios.post(`/invoice-pay-failed-payment/${id}`).then(({ data }) => {
        if (data.success) {
          this.showSuccessMsg(data.message);
          setTimeout(() => {
            this.loadContactData()
          }, 10000);
        } else {
          this.showFailMsg(data.message);
        }
      }).catch(() => {
        this.showFailMsg("Payment capture process fail!");
      })
    }
  }
}
</script>
<style scoped>

</style>
